import { get } from 'lodash'
import { required } from 'utils/validation'

export default function(values = {}, props) {
  const isPersonalReflectionEnabled = get(props, 'isPersonalReflectionEnabled')

  return {
    personalReflection: isPersonalReflectionEnabled && required(get(values, 'personalReflection'))
  }

}